import Phaser, {
    Display
} from 'phaser'

let sections;
let thisSection;
let speeches;
let thisSpeech;
let scenes;
let thisScene;
let xmlData;


export default class XMLLoader extends Phaser.Scene {
    constructor(scene = 'xmlLoader') {
        super(scene);
    }

    init() {

    }
    loadThis(xml) {
        //reset variables for next xml file
        speeches = sections = "";
        thisSection = thisSpeech = thisScene = 0;

        // let xml = arguments[0];
        if (this.cache.xml.get(xml.id)) {
            this.finishedLoading(xml);
        } else {
            this.load.xml(xml.id, xml.path);
            this.load.on('complete', this.finishedLoading.bind(this, xml));
            this.load.start();
        }
    }

    finishedLoading(xml) {

        this.load.removeAllListeners();
        this.load.reset();
        xmlData = this.cache.xml.get(xml.id);

        scenes = xmlData.getElementsByTagName('scene');
        sections = xmlData.getElementsByTagName('section');
        this.setSection(xml.section);

        xml.callback();
    }

    getAllXML() {
        return xmlData;
    }

    getSection(thisName) {

        return (sections[thisSection]);
    }

    setSection(val, thisAtt = 'name') {

        //If there is only 1 section don't search for the name
        let length = sections.length;
        let att;

        if (length == 1) {
            thisSection = 0;
        } else {
            for (let index = 0; index < sections.length; index++) {
                att = sections[index].getAttribute(thisAtt);
                if (att == val) {
                    thisSection = index;

                }
            }
        }

        thisSpeech = 0;
        speeches = sections[thisSection].getElementsByTagName('speech');
    }

    incSpeech() {
        if (thisSpeech < speeches.length - 1) {
            thisSpeech++;
            this.events.emit('changeSpeech');
        }
        if (thisSpeech == speeches.length - 1) this.events.emit('endOfSpeech');
    }
    decSpeech() {

        if (thisSpeech > 0) {
            thisSpeech--;
            this.events.emit('changeSpeech');
        }
        if (thisSpeech == 0) this.events.emit('startOfSpeech');

    }

    getSpeaker() {
        let speaker = speeches[thisSpeech].getAttribute('speaker');
        if (speaker == null) speaker = 'marama';
        return (speaker);
    }

    getThisSpeech() {
        return (thisSpeech);
    }
    getSpeech() {
        return (speeches[thisSpeech]);
    }
    getEnglish(xml = "") {
        if (!xml) xml = speeches[thisSpeech];
        return (xml.getElementsByTagName('english')[0].innerHTML.trim());
    }
    getMaori(xml = "") {
        if (!xml) xml = speeches[thisSpeech];
        return (xml.getElementsByTagName('maori')[0].innerHTML.trim());
    }
    getLanguage(xml = speeches[thisSpeech]) {
        //if (!xml) xml = speeches[thisSpeech];
        if (this.registry.values.isEnglish) {
            return (xml.getElementsByTagName('english')[0].innerHTML.trim());
        } else {
            return (xml.getElementsByTagName('maori')[0].innerHTML.trim());
        }
    }
    getLanguageTag(xml = speeches[thisSpeech]) {

        if (this.registry.values.isEnglish) {
            return (xml.getElementsByTagName('english')[0]);
        } else {
            return (xml.getElementsByTagName('maori')[0]);
        }
    }
    getSpeechLength() {
        return (speeches.length);
    }
    getAttribute(val, xml = speeches[thisSpeech]) {

        if (!xml) xml = speeches[thisSpeech];


        return (xml.getAttribute(val));
    }
    getSectionAttribute(val) {
        return (sections[thisSection].getAttribute(val));
    }
    getSceneAttribute(val) {
        return (scenes[thisScene].getAttribute(val));
    }

    setSpeech(val) {
        //If there is only 1 section don't search for the name
        let length = speeches.length;
        let name;

        if (length == 1) {
            thisSpeech = 0;
        } else {
            for (let index = 0; index < speeches.length; index++) {
                name = speeches[index].getAttribute('name');

                if (name == val) {
                    thisSpeech = index;
                }
            }
        }

        //speeches = sections[thisSection].getElementsByTagName('speech');
    }
    setSpeechNum(num) {
        thisSpeech = num;
    }

    getTitle() {
        let title = sections[thisSection].getElementsByTagName('title');
        title = title[0].innerHTML.trim();
        return (title);
    }
    getTagFromSection(val) {
        return (sections[thisSection].getElementsByTagName(val));
    }
    getTagFromSpeech(val) {
        return (speeches[thisSpeech].getElementsByTagName(val));
    }
    getTag(val, xml) {
        if (!xml) xml = speeches[thisSpeech];
        return (xml.getElementsByTagName(val));
    }
    getTagText(val, xml = speeches[thisSpeech]) {
        try {
            let thisTag = xml.getElementsByTagName(val);
            return (thisTag[0].innerHTML.trim());
        } catch {
            return null;
        }
    }

}